'use strict';

$('header').addClass('minimize');
$('main').addClass('minimize');
$('.nav-icon-pad').addClass('minimize');

$(".format-pnr").on("change keydown paste input", function () {
    $(this).mask('00000000000');
});

$(".format-regnr").on("change keydown paste input", function () {
    $(this).mask('SS 00000');
});

$(".format-year").on("change keydown paste input", function () {
    $(this).mask('0000');
});

$(".format-phone").on("change keydown paste input", function () {
    $(this).val().charAt(0) === "9" || $(this).val().charAt(0) === "4" ? $(this).mask("000 00 000") : $(this).mask("00 00 00 00");
});

$(".format-post").on("change keydown paste input", function () {
    $(this).mask('0000 SSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSSS');
});

$(".format-wheel").on("change keydown paste input", function () {
    $(this).mask('000/00S00');
});

$('#regdata-form').on('submit', function () {
    var form = $('#regdata-form');
    form.validate();
    var isFormValid = form.valid();
    if (isFormValid) {
        btnAnimation();
        return true;
    } else {
        return false;
    }
});